<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search"
                        class="transaction-search"
                        :search-condition="searchCondition"
                        :hideFuzzySearch="true"
                        router-name="/content/upload">
      </search-component>
      <div class="table-wrapper">
        <custom-table :table-set="tableCondition"
                      :service-function="getUploadList"
                      ref="table"
                      :is-first-automatic-visit="false"
                      :first-parameters="getInitParams()"
                      router-name="/content/upload">
        </custom-table>
      </div>
    </div>
  </div>
</template>
<script>
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { getWeekParams, initWeek, initToday, getTodayParams } from '@/utils/tools/time';
import UploadService from '@/views/content/api/upload';

export default {
  components: {
    SearchComponent,
    CustomTable,
  },
  data() {
    return {
      searchCondition: [
        {
          key: ['uploadDateTimeBegin', 'uploadDateTimeEnd'],
          name: 'message.dispute.appealFileTime',
          defValue: initToday(),
          type: 'date_time',
        },
        {
          key: 'uploadType',
          name: 'message.collection.type',
          defValue: '',
          type: 'select',
          options: [],
        },
        {
          key: 'uploadStatus',
          name: 'message.tableCommon.status',
          defValue: '',
          type: 'select',
          options: [],
        },
      ],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.dispute.appealFileTime' },
          key: 'uploadDateTime',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.fileName' },
          key: 'fileName',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.collection.type' },
          key: 'uploadType',
          type: 'text',
          textFunc: (row) => getEnantiomericValue(this.uploadTypeList, row.uploadType),
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.restoreDetaileddeclarationNumber' },
          key: 'id',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.count' },
          key: 'totalNumber',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.successCount' },
          key: 'successNumber',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.failedCount' },
          key: 'failNumber',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'uploadStatus',
          type: 'text',
          textFunc: (row) => getEnantiomericValue(this.uploadStatusList, row.uploadStatus),
        },
        {
          titleBar: { type: 'operations', title: 'message.tableCommon.operation' },
          key: 'buttons',
          type: 'operations',
          subTableDisplays: [
            { // 失败、部分成功的记录支持下载失败文件
              type: 'text_button',
              textFunc: () => 'message.tableCommon.downloadResultFile',
              // permissionCode: 'content.upload.downloadFailedFile',
              isDisplayFunc: (row) => !!row.fileFailUrl,
              func: (row) => {
                window.open(row.fileFailUrl);
              },
            },
          ],
        },
      ],
      uploadTypeList: [],
      uploadStatusList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...UploadService,
    getInitParams() {
      return getTodayParams('uploadDateTimeBegin', 'uploadDateTimeEnd');
    },
    async init() {
      const dict = await GlobalData.getDictList(['MERC_UPLOAD_TYPE', 'UPLOAD_STATUS']);
      this.uploadTypeList = initSelectedData(dict.MERC_UPLOAD_TYPE);
      this.uploadStatusList = initSelectedData(dict.UPLOAD_STATUS);
      this.$refs.search.setSearchSelectOptions('uploadType', this.uploadTypeList);
      this.$refs.search.setSearchSelectOptions('uploadStatus', this.uploadStatusList);
      this.$refs.table.firstVisitHttp();
    },
  },
};
</script>
